<template>
  <div class="queryresults">
    <mt-header title="全国农产品溯源开发中心" fixed>
      <router-link to="/" slot="left">
        <img src="../../static/images/logo.png" alt />
      </router-link>
    </mt-header>
    <div class="content">
      <div class="details">
        <div class="address h-f-c-sb">
          <div class="text">
            <img src="../../static/images/searchresult/position.png" alt />
            <span>{{ address || '暂无信息' }}</span>
          </div>
          <div class="h-f-c-c scan">
            扫码位置
            <img src="../../static/images/searchresult/sweepcode.png" alt />
          </div>
        </div>
        <div class="querynum">
          防伪查询：该标签被扫描次数
          <p>{{ yuandata.look_num }}次</p>
        </div>
        <div class="querygui">
          <p>扫码轨迹：</p>
          <div class="querystyle">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="index of curr" :key="index">
                  <div class="swiper">
                    <div class="swiperline"></div>
                  </div>
                  <div class="swipercircular">
                    <img src="../../static/images/searchresult/xz.png" alt />
                    <img src="../../static/images/searchresult/xz.png" alt />
                    <img src="../../static/images/searchresult/xz.png" alt />
                    <img src="../../static/images/searchresult/xz.png" alt />
                    <img src="../../static/images/searchresult/xz.png" alt />
                    <img src="../../static/images/searchresult/xz.png" alt />
                  </div>
                </div>

                <div class="swiper-slide" v-show="endcurr">
                  <div class="swiper">
                    <div class="swiperline"></div>
                  </div>
                  <div class="swipercircular">
                    <img
                      v-for="index of endcurr"
                      :key="index"
                      src="../../static/images/searchresult/xz.png"
                      alt
                    />
                  </div>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
        <div class="firstsweep">
          <p>
            第一次被扫描的时间：
            <span>{{datatime ? datatime : "暂未扫描"}}</span>
          </p>
        </div>
        <div class="picture">
          <div class="pictop"></div>
          <div class="videopic">
            <img v-if="imgshow == 1" class="details-img" :src="'/' + pagedata.goods_mainshow" alt />
            <video
              v-if="imgshow == 0"
              controls="true"
              style="width: 100%;height: 6.7rem;"
              :src="'/' + pagedata.goods_video"
              alt
            />
            <div class="goods-name" v-if="imgshow == 1">{{ pagedata.goods_name }}</div>
          </div>
          <div class="changevideo">
            <div class="h-f-c-sb" v-if="pagedata.apply_states == 1">
              <div class="s-f-c-c num">
                防伪溯源编码
                <span>{{ yuandata.sign_number }}</span>
              </div>
            </div>
            <div class="imgshow" v-if="pagedata.goods_video">
              <span :class="imgshow == 1 ? 'active' : ''" @click="imgshow = 1">图片</span>
              /
              <span :class="imgshow == 0 ? 'active' : ''" @click="imgshow = 0">视频</span>
            </div>
          </div>
          <div class="picbottom"></div>
        </div>
      </div>
      <div class="box shopinfo">
        <router-link :to="'/companyprofile?store_id=' + pagedata.store_id">
          <div class="pictop"></div>
          <div class="title h-f-c-sb">
            <span class="whilt">供应企业</span>
            <div class="name">{{ shopdata.store_name }}</div>
            <img src="../../static/images/searchresult/shut.png" alt />
          </div>
        </router-link>
        <div style="width: 92%;height: 1px;background: #0Efcff;margin: 0.3rem 0.3rem;"></div>
        <a href="https://www.znstny.cn/">
          <div class="title h-f-c-sb">
            <span class="titleall title">溯源支持</span>
            <div class="name">全国农产品信用体系平台</div>
            <img src="../../static/images/searchresult/shut.png" alt />
          </div>
        </a>
      </div>
      <div class="picbottom"></div>
      <div class="pictop"></div>
      <div class="box boss">
        <div class="title">
          产品参数
          <img
            class="bui"
            @click="isShow = !isShow"
            :class="isShow ? 'down' : 'up'"
            src="../../static/images/searchresult/shut.png"
            alt
          />
        </div>
        <div v-show="isShow">
          <p class="text">
            产品名称：
            <span>{{ pagedata.goods_name }}</span>
          </p>
          <p class="text" v-if="pagedata.brand_name">
            品种名称：
            <span>{{ pagedata.brand_name }}</span>
          </p>
          <p class="text">规格等级：{{ pagedata.norms }}</p>
          <p class="text">上市时间：{{ pagedata.season_time }}</p>
          <p class="text">
            生产规模：
            <span>{{ pagedata.produce_num }}</span>
          </p>
          <p class="text">上市总量：{{ pagedata.season_num }}</p>
        </div>
      </div>
      <div class="picbottom"></div>
      <div class="pictop"></div>
      <div class="box boss">
        <div class="title">
          溯源信息
          <img
            class="bui"
            @click="isShow1 = !isShow1"
            :class="isShow1 ? 'down' : 'up'"
            src="../../static/images/searchresult/shut.png"
            alt
          />
        </div>
        <div v-if="isShow1">
          <p class="text">
            <span class="dd" v-if="pagedata.sort_id == 1">土壤环境</span>
            <span class="dd" v-if="pagedata.sort_id == 2">生长环境</span>
            <span class="dd" v-if="pagedata.sort_id == 3">水产环境</span>
            <span class="dd" v-if="pagedata.sort_id == 4">生产环境</span>
            ：
            <span class="txt">{{ pagedata.environment }}</span>
          </p>
          <p class="text">
            <span class="dd" v-if="pagedata.sort_id == 1">肥料来源</span>
            <span class="dd" v-if="pagedata.sort_id == 2">饲料来源</span>
            <span class="dd" v-if="pagedata.sort_id == 3">饲料来源</span>
            <span class="dd" v-if="pagedata.sort_id == 4">原料来源</span>
            ：
            <span class="txt">{{ pagedata.material }}</span>
          </p>
          <p class="text">
            <span class="dd" v-if="pagedata.sort_id == 1">用药来源</span>
            <span class="dd" v-if="pagedata.sort_id == 2">用药来源</span>
            <span class="dd" v-if="pagedata.sort_id == 3">水质等级</span>
            <span class="dd" v-if="pagedata.sort_id == 4">卫生等级</span>
            ：
            <span class="txt">{{ pagedata.health }}</span>
          </p>
          <p class="text">
            <span class="dd" v-if="pagedata.sort_id == 1">生长环境</span>
            <span class="dd" v-if="pagedata.sort_id == 2">饲宿环境</span>
            <span class="dd" v-if="pagedata.sort_id == 3">水质含量</span>
            <span class="dd" v-if="pagedata.sort_id == 4">营养含量</span>
            ：
            <span class="txt">{{ pagedata.nutrition }}</span>
          </p>
          <p class="text">
            生产负责人：
            <span>{{ pagedata.product_header }}</span>
          </p>
          <p class="text">
            物流负责人：
            <span>{{ pagedata.shipping_header }}</span>
          </p>
          <p class="text">
            品质等级：
            <span>{{ pagedata.quality }}</span>
          </p>
          <p class="text">
            生长坐标：
            <span>{{ pagedata.address }}</span>
          </p>
        </div>
      </div>
      <div class="picbottom"></div>
      <div class="pictop"></div>
      <div class="box boss">
        <div class="title">
          生长过程
          <img
            class="bui"
            @click="isShow2 = !isShow2"
            :class="isShow2 ? 'down' : 'up'"
            src="../../static/images/searchresult/shut.png"
            alt
          />
        </div>
        <div v-show="isShow2" class="progress" v-for="(item, index) in pagedata.grow" :key="index">
          <div class="dec">
            <a :href="'/' + item.photo">
              <img :src="'/' + item.photo" alt />
            </a>
            <div class="name">
              {{ item.step_describe }}
              <p>{{ item.grow_date }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="picbottom"></div>
    </div>
    <div class="bottom_btn">
        <li @click="$router.back(-1)" v-if="ly">返回</li>
        <li @click="$router.push('/')" v-else>首页</li>
        <li class="buy" v-if="pagedata.href"><a :href="'https://shop.znstny.cn/Mobile/Goods/goodsInfo/id/'+pagedata.href+'.html'">购买</a></li>
      </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

import { Toast, MessageBox } from "mint-ui";
export default {
  data() {
    return {
      ly:'',
      identity:'',
      goods_id: "",
      pagedata: {},
      yuandata: {},
      shopdata: {},
      imgshow: 1,
      address: "",
      isShow: true,
      isShow1: true,
      isShow2: true,
      sign_number: "",
      datatime: "",
      query_log_count: 0,
      curr: 0,
      endcurr: 0
    };
  },
  created() {
    this.goods_id = this.$route.query.goods_id || "";
    this.sign_number = this.$route.query.sign_number || "";
    this.ly = this.$route.query._d || "";
    this.identity = this.$route.query.identity || "";
    this.getPageData();
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      pagination: {
        el: ".swiper-pagination"
      }
    });
  },
  methods: {
    getPageData() {
      let url = "/front/api/showSignAndGoods";
      this.$request.post(
        url,
        {
          sign_number: this.sign_number,
          goods_id: this.goods_id,
          identity:this.identity
        },
        res => {
          console.log(res);
          if (res.status == 1) {
            document.title =
              res.result.goods.goods_name + "-数字农业共享区块链溯源平台";
            this.pagedata = res.result.goods;
            this.href = res.result.goods.href;
            this.address = res.result.region;
            this.shopdata = res.result.store;
            this.yuandata = res.result.sign;
            this.datatime = res.result.fist_time;
            this.query_log_count = res.result.query_log_count;
            this.curr = parseInt(res.result.query_log_count / 6);
            this.endcurr = res.result.query_log_count % 6;
            this.getShopData();
          } else {
            MessageBox.confirm("您输入的溯源码不正确", "提示")
              .then(action => {
                if (action == "confirm") {
                  this.$router.push("/search");
                }
              })
              .catch(err => {
                if (err == "cancel") {
                  this.$router.push("/");
                }
              });
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.dd {
  width: 1.3rem;
}
.mint-header {
  height: 1rem;
}
.swipercircular {
  top: 0;
  position: absolute;
  padding: 0.06rem 0 0 0;
  img {
    margin-left: 0.45rem;
  }
}
.swiperline {
  height: 1px;
  border-bottom: 1px dashed #0efcff;
  margin: 0.3rem 0.9rem;
}
.swiper-slide {
  height: 1.2rem;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
}
.swiper-pagination {
  bottom: 0;
}
.swiper-container {
  --swiper-theme-color: #20f0f4;
  z-index: 0;
}
.swiper-container {
  width: 100%;
  margin: 20px auto;
  color: #0efcff;
}
.wid {
  width: 1.2rem;
}
.bui {
  width: 0.3rem;
  height: 0.15rem;
}
.boss {
  padding: 0 0.4rem;
}
.pictop {
  height: 0.24rem;
  width: 100%;
  margin-top: 0.2rem;
  background-image: url("../../static/images/searchresult/pictop.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.picbottom {
  height: 0.24rem;
  width: 100%;
  background-image: url("../../static/images/searchresult/picbottom.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.whilt {
  color: #ffffff;
}
.text span {
  color: #0efcff;
}
.mint-header {
  background: rgb(5, 15, 37);
  color: #0efcff;
  font-size: 16px;
  .mint-header-button {
    a {
      img {
        width: 0.8rem;
        height: 0.6rem;
      }
    }
  }
}
.content {
  padding: 54px 16px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-image: url("../../static/images/searchresult/usersweepp.png");
  .querynum {
    color: #0efcff;
    display: flex;
    padding-top: 0.2rem;
    justify-content: space-between;
  }
  .querygui {
    color: #0efcff;
    padding: 0.2rem 0;
    p {
      padding-bottom: 0.1rem;
    }
    .querystyle {
      width: 100%;
      height: 1rem;
    }
  }
  .firstsweep {
    color: #ffffff;
    text-align: center;
    padding-top: 0.1rem;
    padding-bottom: 0.4rem;
  }
  .changevideo {
    display: flex;
    justify-content: space-between;
    padding: 0 0.4rem;
  }
  .picture {
    background-image: url("../../static/images/searchresult/picline.png");
    background-repeat: repeat-y;
    background-size: 100% 100%;
    .videopic {
      position: relative;
      padding: 0.2rem 0.4rem;
    }
  }
}
.queryresults {
  padding-bottom: 1rem;
  background-color: rgb(0, 17, 49);
}
.details {
  .details-img {
    display: block;
    width: 100%;
    height: 6.7rem;
    background: gainsboro;
  }
  .goods-name {
    height: 0.6rem;
    line-height: 0.6rem;
    background-color: #021f3e;
    font-size: 0.25rem;
    text-align: center;
    color: white;
    bottom: 0;
    width: 100%;
    z-index: 100;
  }
  .imgshow {
    margin-top: 0.15rem;
    text-align: right;
    color: rgb(76, 144, 139);
    .active {
      color: #0efcff;
    }
  }
  .h-f-c-sb {
    margin: 0.3rem 0;
    color: #ffffff;
    .num {
      span {
        margin-top: 0.1rem;
      }
    }
  }
  .time {
    font-size: 0.26rem;
    span {
      margin-top: 0.1rem;
      padding: 0 0.2rem;
      height: 0.55rem;
      border-radius: 5px;
    }
  }
  .address {
    font-size: 0.26rem;
    img {
      width: 0.4rem;
    }
    .text {
      display: flex;
      align-items: center;
      span {
        width: 4.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      img {
        margin-right: 0.1rem;
      }
    }
    .scan {
      color: #0efcff;
      img {
        margin-left: 0.1rem;
      }
    }
  }
}
.box {
  color: #0efcff;
  background-image: url("../../static/images/searchresult/picline.png");
  background-repeat: repeat-y;
  background-size: 100% 100%;
  .title {
    font-size: 0.3rem;
    font-weight: bold;
    color: #ffffff;
    position: relative;
    img {
      width: 0.3rem;
      height: 0.15rem;
    }
    .name {
      color: #0efcff;
    }
    .down {
      position: absolute;
      top: 50%;
      right: 0.2rem;
      transform: translateY(-50%) rotate(90deg);
    }
    .up {
      position: absolute;
      top: 50%;
      right: 0.2rem;
      transform: translateY(-50%) rotate(180deg);
    }
  }
  p {
    margin-top: 0.2rem;
    width: 100%;
    font-size: 0.26rem;
  }
  .text {
    display: flex;
    align-items: flex-start;
    .txt {
      width: 5rem;
      margin-left: 0.2rem;
    }
  }
  .progress {
    display: flex;
    align-items: center;
    width: 6.5rem;
    padding: 0.2rem 0;
    .date {
      width: 1.5rem;
      text-align: center;
    }
    .dec {
      width: 88%;
      background: #021f3e;
      border-radius: 0.2rem;
      display: flex;
      margin-left: 0.2rem;
      padding: 0.15rem;
      img {
        display: block;
        width: 1.4rem;
        height: 1.4rem;
      }
      .name {
        width: 3rem;
        margin-left: 0.2rem;
      }
    }
  }
}
.shopinfo {
  margin-top: 0.4rem;
  a {
  }
  .h-f-c-sb {
    margin: 0 0.3rem;
  }
  .name {
    width: 4rem;
    color: #666666;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  img {
    width: 0.3rem;
    height: 0.15rem;
  }
}
.btn {
  position: fixed;
  z-index: 10;
  bottom: 0;
  width: 100%;
  background: #113067;
  height: 1rem;
  line-height: 1rem;
  color: #ffffff;
  text-align: center;
  font-size: 0.32rem;
}

.bottom_btn{
  position: fixed; bottom: 0;right: 0;left: 0;
  display: flex;
  background-color: #113067;
  height: .8rem;
  align-items: center;
  li{
    height: .8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    color: #ffffff;
  }
  li a{
    color: #ffffff
  }
  li.buy{
    background: #b0600a;

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/searchResults.vue